// Smart View definitions for quick navigation

export interface SmartView {
  id: string
  name: string
  category: 'athletes' | 'deals' | 'contacts'
  description?: string
  route: string
  filterParams?: Record<string, string>
}

export const smartViews: SmartView[] = [
  // Athletes
  {
    id: 'my-athletes',
    name: 'My Athletes',
    category: 'athletes',
    description: 'Athletes assigned to you',
    route: '/clients',
    filterParams: { assigned: 'me' }
  },
  {
    id: 'expiring-soon',
    name: 'Expiring Soon',
    category: 'athletes',
    description: 'Contracts expiring in 90 days',
    route: '/clients',
    filterParams: { contractExpiring: '90' }
  },
  {
    id: 'top-earners',
    name: 'Top Earners',
    category: 'athletes',
    description: 'Highest contract values',
    route: '/clients',
    filterParams: { sort: 'contract_value', order: 'desc' }
  },

  // Deals
  {
    id: 'closing-this-month',
    name: 'Closing This Month',
    category: 'deals',
    description: 'Deals with close date this month',
    route: '/deals',
    filterParams: { closeDate: 'this-month' }
  },
  {
    id: 'stalled',
    name: 'Stalled',
    category: 'deals',
    description: 'No activity in 30+ days',
    route: '/deals',
    filterParams: { status: 'stalled' }
  },
  {
    id: 'high-value',
    name: 'High Value',
    category: 'deals',
    description: 'Deals over $1M',
    route: '/deals',
    filterParams: { minValue: '1000000' }
  },

  // Contacts
  {
    id: 'recent-interactions',
    name: 'Recent Interactions',
    category: 'contacts',
    description: 'Contacted in last 7 days',
    route: '/contacts',
    filterParams: { lastContact: '7' }
  },
  {
    id: 'decision-makers',
    name: 'Decision Makers',
    category: 'contacts',
    description: 'Key decision-maker contacts',
    route: '/contacts',
    filterParams: { role: 'decision-maker' }
  }
]

export function getSmartViewsByCategory(category: SmartView['category']): SmartView[] {
  return smartViews.filter(view => view.category === category)
}

export function getSmartViewById(id: string): SmartView | undefined {
  return smartViews.find(view => view.id === id)
}

export function buildSmartViewUrl(view: SmartView): string {
  if (!view.filterParams || Object.keys(view.filterParams).length === 0) {
    return view.route
  }
  const params = new URLSearchParams(view.filterParams)
  return `${view.route}?${params.toString()}`
}

// Category display info
export const categoryInfo: Record<SmartView['category'], { label: string; icon: string }> = {
  athletes: { label: 'Athletes', icon: 'users' },
  deals: { label: 'Deals', icon: 'file-text' },
  contacts: { label: 'Contacts', icon: 'book' }
}
